export const initialState = {
    loader: false,
    addressList: [],
    error: ''
}